/**
 * Determines if a given response object is using all default values. Ex:
 * When an empty proto response is returned from a mid-tier handler.
 */ export function isDefaultResponse(response) {
    if (!response) {
        return true;
    }
    return Object.values(response).every(function(value) {
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        return !value;
    });
}
